// extracted by mini-css-extract-plugin
export default {"primaryColor":"#303036","secondaryColor":"#fff","danger":"#ff7e6b","complementaryColorDark":"#303036","complementaryColorLight":"#007b3f"};